<template>
  <b-overlay :show="isLoading" rounded="sm">
    <template #overlay>
      <div class="uni-loading">
        <div :style="'color:' + footerColors[2] + ' !important'">
          <i :class="' ' + loadingIcon"></i>
        </div>
      </div>
    </template>
    <router-view></router-view>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  data() {
    return {
      colore: ""
    };
  },
  computed: {
    ...mapGetters("_commonModule", ["isLoading", "loadingIcon"]),
    ...mapGetters("_colorsModule", ["cardColors", "footerColors"])
  },
  mounted: function() {
  }
};
</script>

<style>
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/css/font-awesome.min.css";
/* Import Bootstrap Vue Styles */
/* @import "~bootstrap-vue/dist/bootstrap-vue.css"; */
@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style lang="scss">
// Import Main styles for this application
@import "./scss/style";

//https://coolors.co/20bf55-0b4f6c-01baef-fbfbff-757575

#nprogress .bar {
  height: 6px;
}
.card {
  background-color: #e7f8fd !important;
  .card-header {
    background-color: #43b2e1 !important; //#89c1e9; // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
    color: #fbfbff !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    div {
      padding: 0.75rem 1.25rem !important;
    }
  }
}
.app-header.navbar {
  background-color: #20bf55; //#89c1e9;
}

body {
  background-color: #fbfbff !important;
}

.sidebar {
  background-color: #0b4f6c; //#0B4F6C;
}

.app-header.navbar .navbar-brand {
  background-color: #fbfbff; //!important
  width: 290px !important;
}

.el-collapse-item,
.el-collapse-item__header,
.el-collapse-item__content,
.el-collapse-item__wrap {
  background-color: transparent !important;
}

.sidebar .nav-link i,
.sidebar .navbar .dropdown-toggle i,
.navbar .sidebar .dropdown-toggle i {
  color: #20bf55; //!important;
}

.sidebar .nav-link.active i,
.sidebar .navbar .active.dropdown-toggle i,
.navbar .sidebar .active.dropdown-toggle i {
  color: #fbfbff; //!important;
}

.k-widget {
  font-size: inherit !important;
}

a.open > i {
  color: white !important;
}

a.open > div > i {
  color: white !important;
}

.btn-default {
  background-color: #0b4f6c !important;
  border-radius: 2px !important;
  color: white !important;
  text-transform: uppercase;
  margin: 2px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
  &.info {
    $color: rgba(#004499, 0.9);
    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
    .tooltip-arrow {
      border-color: $color;
    }
  }
  &.popover {
    $color: #f9f9f9;
    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
    .popover-arrow {
      border-color: $color;
    }
  }
}
.breathing-icon {
  -webkit-animation: breathing 5s ease-out infinite normal;
  animation: breathing 2s ease-out infinite normal;
  -webkit-font-smoothing: antialiased;
}

@-webkit-keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
}

@keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }
}
.uni-loading {
  display: inline-block;
  transform: translateZ(1px);
}
.uni-loading > div {
  display: inline-block;
  animation: uni-loading 15s cubic-bezier(0.1, 0.1, 0.1, 0.1) infinite;
}
@keyframes uni-loading {
  0%,
  100% {
    animation-timing-function: cubic-bezier(0.1, 0.1, 0.1, 0.1);
  }
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0.1, 0.1, 0.1, 0.1);
  }
  100% {
    transform: rotateY(3600deg);
  }
}
</style>
